import { ProgressLoaderAssurantService } from 'src/app/core/core';
import { Component, OnInit, OnDestroy, Input, input } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';


@Component({
    selector: 'assurant-loader',
    templateUrl: './assurant-loader.component.html',
    styleUrls: ['./assurant-loader.component.scss'],
    imports: []
})
export class AssurantLoaderComponent implements OnInit, OnDestroy {

  readonly showProgress = input(false);
  @Input()
  message = '';
  show = false;
  private subscription: Subscription;
  constructor(private loaderService: ProgressLoaderAssurantService) {}
  ngOnInit() {
    if(this.showProgress()) {
      return;
    }
    this.subscription = this.loaderService.loaderState.subscribe(value => {
      this.show = value.show;
    });
  }
  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
